import { render, staticRenderFns } from "./CreateProdukGroup.vue?vue&type=template&id=ebd75f64&scoped=true"
import script from "./CreateProdukGroup.vue?vue&type=script&lang=js"
export * from "./CreateProdukGroup.vue?vue&type=script&lang=js"
import style0 from "./CreateProdukGroup.vue?vue&type=style&index=0&id=ebd75f64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebd75f64",
  null
  
)

export default component.exports